import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

export const DataCardsWrapper = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
	grid-gap: 2rem;

	@media ${Breakpoints.tablet} {
		grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
	}

	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const DataCard = styled.div`
	border: 1px solid var(--border-color);
	cursor: ${({ onClick }) => (onClick ? 'pointer' : 'unset')};
	padding: ${({ isLoading, onClick }) =>
		isLoading || !onClick
			? 'var(--padding-4) var(--padding-2)'
			: 'var(--padding-4) var(--padding-2) var(--padding-2)'};
	background-color: var(--white);
	border-radius: var(--small-border-radius);
	display: grid;
`;

export const CardContentWrapper = styled.div`
	display: grid;
	grid-template-columns: 5rem auto 2rem;
	gap: var(--margin-4);
`;

export const Value = css`
	max-width: 70%;
	@media ${Breakpoints.mobile} {
		max-width: 100%;
	}
`;

export const ViewLink = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
	justify-self: end;
	background: transparent;
	border-color: transparent;
	color: var(--blue);

	body[dir='rtl'] & {
		.icon {
			transform: scale(-1, 1);
		}
	}
`;

export const IconVariation = styled(Icon)`
	background-color: ${({ backgroundcolor }) => backgroundcolor};
	color: ${({ color }) => color};
	font-size: 3rem !important;
	border-radius: var(--small-border-radius);
	width: 5rem;
	height: 5rem;
	display: flex;
	justify-content: center;
	align-items: center;
`;
